"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/user/list");
exports.initialState = {
    status: 'STANDBY',
    error: undefined,
    list: [],
    searchString: '',
    limit: 20,
    offset: 0,
    total: 0,
    order: 'asc',
    orderBy: 'name',
    orderDropdownToggled: false
};
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const listLens = monocle.Lens.fromProp('list');
const totalLens = monocle.Lens.fromProp('total');
const errorLens = monocle.Lens.fromProp('error');
const searchStringLens = monocle.Lens.fromProp('searchString');
const limitLens = monocle.Lens.fromProp('limit');
const offsetLens = monocle.Lens.fromProp('offset');
const orderLens = monocle.Lens.fromProp('order');
const orderByLens = monocle.Lens.fromProp('orderBy');
const orderDropdownToggledLens = monocle.Lens.fromProp('orderDropdownToggled');
const methods = {};
exports.methods = methods;
methods[Actions.FETCH_USER_LIST_REQUEST] = (state, action) => {
    if (typeof action.payload.search === 'string' &&
        action.payload.search.length > 0) {
        return statusLens.set('FETCHING')(state);
    }
    else {
        return statusLens.set('STANDBY')(state);
    }
};
methods[Actions.FETCH_USER_LIST_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), totalLens.set(action.payload.total), listLens.set(action.payload.users))(state);
methods[Actions.FETCH_USER_LIST_FAILED] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload))(state);
methods[Actions.SET_SEARCH_STRING] = (state, action) => searchStringLens.set(action.payload)(state);
methods[Actions.SET_LIMIT] = (state, action) => limitLens.set(action.payload)(state);
methods[Actions.SET_OFFSET] = (state, action) => offsetLens.set(action.payload)(state);
methods[Actions.SET_ORDER] = (state, action) => orderLens.set(action.payload)(state);
methods[Actions.SET_ORDER_BY] = (state, action) => orderByLens.set(action.payload)(state);
methods[Actions.TOGGLE_SORT_BY_DROPDOWN] = (state) => orderDropdownToggledLens.modify((val) => !val)(state);
methods[Actions.CLEAR] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=list.js.map